<template>
   <body>
      <div class="wrapper">
         <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <a class="navbar-brand" href="#">{{appShortName}}</a>
         </nav>
         <div class="container" style="min-height: 653px;">
            <div class="row justify-content-center">
               <div class="wrapper-validar row justify-content-center">
                  <div class="col-md-10 p-2 m-2">
                     <div class="card card-primary">
                        <div class="card-header">
                           <label><i class="fa fa-globe"></i> Validador Público</label>
                        </div>
                        <!-- /.panel-heading -->
                        <div class="card-body" id="panelListaAssinaturas">
                           <p>
                              Quando um documento é assinado pelo {{appName}}, um código de
                              verificação e um QR Code ficam disponíveis na última página deste
                              documento.
                              Você pode copiar e colar aqui o código digitável ou usar a câmera de seu
                              celular para ler o QR Code.
                           </p>
                           <p></p>
                           <p>Verifique aqui se o documento está corretamente assinado pelo {{appName}}
                           </p>
                           <p></p>
                           <p> </p>
                           <div class="col-md-12">
                              <div class="form-group">
                                 <label class="control-label" for="Codigo" title="">Código</label>
                                 <div class="input-group input-group-required">
                                    <input v-model="request.file" autofocus="true" class="form-control" id="Codigo"
                                       name="Codigo" placeholder="Digite ou cole o código aqui" type="text" value="">
                                    <span class="input-group-btn">
                                       <button type="button" @click="sendRequest()"
                                          class="btn btn-primary float-left btn-flat"><i class="fa fa-check"></i>
                                          Validar</button>
                                    </span>
                                 </div>
                              </div>
                           </div>

                           <div><b>Exclusivo para documentos assinados pelo {{appName}}.</b>
                           </div>
                        </div>
                        <div class="validation-summary-valid text-danger" data-valmsg-summary="true">
                           <ul>
                              <li style="display:none"></li>
                           </ul>
                        </div>
                     </div>
                     <div class="panel-body bg-white">
                        <p> Você também pode atestar se um documento assinado com certificado digital
                           através do {{appName}} está em Conformidade com o Padrão Brasileiro
                           de
                           Assinatura Digital padrão ICP-Brasil, e se o mesmo observa as normas regidas
                           pelo Instituto Nacional de Tecnologia da Informação (www.iti.gov.br) e
                           ICP-Brasil contidas no documento público DOC ICP-15 clicando <a
                              href="https://verificador.iti.gov.br/" target="_blank">aqui</a> (você
                           será
                           direcionado para o site do ITI).
                        </p>
                        <p></p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <footer>
         <div class="main-footer clearfix" style="margin-left:0px">
            <div class="hidden-xs">
               <b>{{appName}} versão 2.0</b>
            </div>
         </div>
      </footer>
   </body>
</template>
<script>
   export default {
      data() {
         return {
            request: {
               file: null
            }
         }
      },
      beforeMount() {
         if (this.$route.query.chave) {
            this.request.file = this.$route.query.chave;
         }
      },
      methods: {
         sendRequest() {
            this.$router.push(`/validador?arquivo=${this.request.file}`);
         }
      }
   }
</script>

<style lang="css" scoped>
   body {
      background-image: url("../../assets/email-pattern.png");
   }
</style>